import { createContext } from "react";

const FabricantesContext = createContext();

export default FabricantesContext;
